import { render } from "./VerificationOtp.vue?vue&type=template&id=2b148190"
import script from "./VerificationOtp.vue?vue&type=script&lang=js"
export * from "./VerificationOtp.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__